export const AUTH_TOKEN = 'auth-token';
export const ACCESS_TOKEN = 'access-token';
